import {BaseRepository} from "../../../infrastructure/repositories/base-repository";
import {DomUtils} from "../../../infrastructure/utils/dom-utils";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {SiteConfig} from "../../../core/bootstrap/models/site-config";
import {DeviceStore} from "../../../core/app/device.store";
import {AthleteEventsChartApiService} from "./athlete-events-chart.api-service";
import {AthleteEventsChartFactory} from "./athlete-events-chart.factory";

export class AthleteEventsChartRepository extends BaseRepository {
  static injectables = [DomUtils, LoggerUtils, SiteConfig, DeviceStore, AthleteEventsChartApiService, AthleteEventsChartFactory];
}
